export default {
  form: {
    header: 'Ready!',
    errorHeader: 'Oh no, something went wrong!',
    getRecommendations: 'start again',
  },
  results: {
    header: 'WHAT WE THINK:',
    previousResultsHeader: 'HERE’S YOUR PREVIOUS SUGGESTION:',
    favouritesHeader: 'OUR FAVOURITES:',
    topMatch: 'TOP MATCHES:',
    rate: 'HOW DO YOU RATE OUR SUGGESTIONS?',
    goodRecommendation: 'Yeah, great!',
    badRecommendation: 'Could do better',
  },
  resultsError: {
    header: 'Error:',
    description:
      'Maybe it’s best you try again. Sometimes these things happen!',
    descriptionNoPrevResults:
      'It looks like our AI did not respond to your amazing prompt. Please try again for a new result or check out our favourite combinations below.',
  },
  featuredGenres: {
    header: 'Featured Genres',
  },
  featuredMoods: {
    header: 'Featured Moods',
  },
  loader: {
    title: 'Finding you a Soundtrack',
    subtitle1: 'Hang tight for a moment, we’re just figuring out what to do...',
    subtitle2: 'Does anyone know how AI really works?',
    subtitle3: 'Make sure to keep that cup of coffee away from your keyboard! ',
    subtitle4: 'Quick, look out the window, there’s AI everywhere!',
    subtitle5: 'Have I been typed by AI, or a real human? What do you think...',
    subtitle6: 'Looks like we’re almost there, just plugging in the mainframe',
    subtitle7: 'Retrieving data from the satellites...',
    subtitle8:
      'Unboxing AI… Ooooo, it smells really good! Like a new book, remember those!?',
  },
};
